module.exports = __webpack_public_path__ + "img/vi.d250b023.png";